/** @jsxImportSource @emotion/react */
import { jsx, css } from "@emotion/react";
import {
  Grid,
  Avatar,
  Box,
  Button,
  Dialog,
  Slide,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
} from "@mui/material";
import pr from "../lib/pr";
import get_token from "../lib/get_token";
import { useEffect, useState } from "react";
import axios from "axios";
import { loginState, configState } from "../lib/State";
import { useHistory } from "react-router-dom";
import get_cid from "../lib/get_cid";
import get_center from "../lib/get_center";
import send_webview_data from "../lib/send_webview_data";
import Swal from "sweetalert2";
import Receipt from "./Receipt";
import add_comma from "../lib/add_comma";
import moment from "moment";

const MypageLoggedPayment = (props) => {
  const cid = get_cid();
  const center = get_center(cid);
  const [rows, setRows] = useState([]);
  const [receiptOpen, setReceiptOpen] = useState(false);
  const [data, setData] = useState({
    company: center.receipt.company,
    company_no: center.receipt.company_no,
    head: center.receipt.head,
    tel: center.receipt.tel,
    addr: center.receipt.addr,
    amount: 0,
    supply: 0,
    vat: 0,
    buyer_name: "",
    card_name: "",
    card_number: "",
    status: "",
    apply_num: "",
    card_quota: 0,
    name: "",
    paid_at: "",
  });

  // 영수증데이타
  // [
  //     {
  //         id: 0,
  //         payDate: '2021.12.22(수)',
  //         payContent: '클래스 1회권',
  //         payBy: '카드결제',
  //         payState: '결제완료',
  //         cost: '30,000'
  //     },
  //     {
  //         id: 1,
  //         payDate: '2022.01.05(일)',
  //         payContent: '클래스 8회권',
  //         payBy: '무통장 입금',
  //         payState: '결제완료',
  //         cost: '160,000'
  //     },
  //     {
  //         id: 2,
  //         payDate: '2021.02.15(화)',
  //         payContent: '클래스 1회권',
  //         payBy: '무통장 입금',
  //         payState: '결제완료',
  //         cost: '30,000'
  //     },
  //     {
  //         id: 3,
  //         payDate: '2021.02.28(월)',
  //         payContent: '클래스 60회권',
  //         payBy: '카드결제',
  //         payState: '결제완료',
  //         cost: '480,000'
  //     },
  // )

  const { login } = props;
  const [loaded, setLoaded] = useState(false);
  const token = get_token();
  const history = useHistory();
  const [stat, setStat] = useState(false);

  // 쿠폰 가져오기
  const load_data = async () => {
    // pr('load_data');
    let result = await axios.post(configState.api + "/gympass/my_payment", {
      token: token,
      cid: cid,
      mcd: login.mcd,
      level: login.level,
    });
    setRows(result.data.rows);
  };
  useEffect(() => {
    load_data();
  }, []);

  const receipt = async (imp_uid) => {
    let result = await axios.post(configState.api + "/gympass/receipt", {
      imp_uid: imp_uid,
      tier_code: center.tierCode,
    });
    if (result.data.success === 1) {
      setReceiptOpen(true);

      // update
      let amount = parseInt(result.data.row.amount);
      let supply = 0;
      let vat = 0;
      if (amount > 0) {
        supply = Math.ceil((amount / 11) * 10);
        if (supply > 0) {
          vat = amount - supply;
        }
      }

      let status = "";
      if (result.data.row.status === "ready") {
        status = "미결제";
      }
      if (result.data.row.status === "paid") {
        status = "결제완료";
      }
      if (result.data.row.status === "cancelled") {
        status = "결제취소";
      }
      if (result.data.row.status === "failed") {
        status = "결제실패";
      }

      let paid_at = result.data.row.paid_at;
      paid_at = moment.unix(paid_at).format("YYYY.MM.DD HH:mm");

      setData((state) => {
        return {
          ...state,
          amount: add_comma(amount),
          supply: add_comma(supply),
          vat: add_comma(vat),
          buyer_name: result.data.row.buyer_name,
          card_name: result.data.row.card_name,
          card_number: result.data.row.card_number,
          status: status,
          apply_num: result.data.row.apply_num,
          card_quota:
            result.data.row.card_quota == 0
              ? "일시불"
              : result.data.row.card_quota,
          name: result.data.row.name,
          paid_at: paid_at,
        };
      });
    } else {
      Swal.fire("오류", result.data.msg);
      return;
    }
  };

  return (
    <>
      <Receipt
        receiptOpen={receiptOpen}
        setReceiptOpen={setReceiptOpen}
        data={data}
        setData={setData}
      ></Receipt>
      <Grid
        container
        // display="block"
        width="100%"
        // height='100%'
        justifyContent="center"
        alignItems="flex-end"
        position="absolute"
        top="170px"
        overflow="hidden"
        background="red"
      >
        {/* <Box sx={{ height: '120px', background: '#d6d6d6' }}></Box> */}

        {rows.length == 0 && (
          <>
            <Box sx={{ width: "320px", textAlign: "center" }}>
              구매내역이 없습니다.
            </Box>
          </>
        )}

        {rows.length > 0 &&
          rows.map((item, index) => {
            // console.log(item)
            return (
              <Box
                key={index}
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{
                    width: "90%",
                    display: "flex",
                    justifyContent: "flex-start",
                    padding: "0 0 5px 2.5%",
                    fontSize: "13px",
                    color: "#979797",
                    fontWeight: "bold",
                  }}
                >
                  {item.regdate}
                </Box>
                <Box
                  sx={{
                    width: "84%",
                    border: "1px solid #c9c9c9",
                    padding: "10px",
                    marginBottom: "15px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        aligntItems: "center",
                      }}
                    >
                      <img
                        src={`/img/${item.gubun.toLowerCase()}_${(
                          "00" + item.pt_count
                        ).slice(-2)}.jpg`}
                        style={{ width: "76px" }}
                      />
                    </Box>
                    <Box
                      sx={{
                        marginLeft: "10px",
                      }}
                    >
                      <Box
                        sx={{
                          fontWeight: "bold",
                        }}
                      >
                        {item.itemName}
                      </Box>
                      <Box
                        // key={index}
                        sx={{
                          fontSize: "14px",
                        }}
                      >
                        {/* {item.state} */}
                        구매완료
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          fontSize: "14px",
                        }}
                      >
                        <Box>₩{item.amountf}원</Box>
                      </Box>
                      {/* 영수증출력버튼 */}
                    </Box>
                  </Box>
                  {item.imp_uid !== "" && item.amount > 0 && (
                    <Box fontSize="small">
                      <Button
                        variant="contained"
                        size="small"
                        sx={{
                          border: "1px solid #0092a2",
                          background: "white",
                          color: "#0092a2",
                          boxShadow: "none",
                          borderRadius: 0,
                          ":hover": {
                            background: "white",
                          },
                        }}
                        onClick={() => {
                          receipt(item.imp_uid);
                        }}
                      >
                        영수증보기
                      </Button>
                    </Box>
                  )}
                </Box>
              </Box>
            );
          })}
        <Box sx={{ width: "100%", height: "100px" }}></Box>
      </Grid>
    </>
  );
};

export default MypageLoggedPayment;
